export default "__VITE_ASSET__DlnQCu6S__"